import { ENDPOINTS } from "@/settings/api-settings";
import { Observable, from } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function findWhatsappScheduleById(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.WHATSAPP_SCHEDULE}/${id}`)).pipe(map((r: any) => r.data));
}